module.exports = __webpack_public_path__ + "static/4-f937776a7a007b3ccffff481c5cc8110.mp4";